interface Props {
  activeColor: string;
}
const AiIcon = (props: Props) => {
  const activeColor = props.activeColor ? props.activeColor : "#0f1560";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 32 32"
      fill={activeColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 8
           C13 14.5 16.5 17.5 21.5 19
           C16.5 20.5 13 23.5 11.5 30
           C10 23.5 6.5 20.5 1.5 19
           C6.5 17.5 10 14.5 11.5 8Z"
      />

      <path
        d="M22.5 4.2
           C23.3 7 25.5 9.7 28 10.5
           C25.5 11.3 23.3 14 22.5 16.8
           C21.7 14 19.5 11.3 17 10.5
           C19.5 9.7 21.7 7 22.5 4.2Z"
      />

      <path
        d="M25 18.5
           C25.8 21.5 28 24 30.5 24.8
           C28 25.6 25.8 28 25 31
           C24.2 28 22 25.6 19.5 24.8
           C22 24 24.2 21.5 25 18.5Z"
      />
    </svg>
  );
};

export default AiIcon;
